import React from 'react';
import { TextField, Typography, Grid } from '@mui/material';

const HelpfilesComponent = ({ selectedServer }) => {
  // Check if selectedServer and its nested properties exist
  const gameExists = selectedServer?.game;
  const isMobile = gameExists && selectedServer?.game?.platform === 'HTML5 - Mobile';

  // Safely generate Desktop Help URL
  const helpDesktop = gameExists
    ? `https://redirector3.valueactive.eu/Casino/Default.aspx?applicationid=1019&serverid=${selectedServer.serverId}&moduleid=${selectedServer.game.moduleId}&clientid=${selectedServer.game.clientId}&helpsystemid=10001&lang=${selectedServer.language.shortCode}`
    : 'Invalid Server Data';

  // Safely generate Mobile Help URL
  const helpMobile = gameExists
    ? `https://info.valueactive.eu/${selectedServer.market.mobileWebHelp}/${selectedServer.language.shortCode}/default.htm?cshid=${selectedServer.game.moduleId}${selectedServer.game.clientId}`
    : 'Invalid Server Data';

  return (
    <div>
      {/* Helpfile Instructions */}
      <Grid container alignItems="center" justifyContent="flex-start">
        <Typography variant="body1">
          Generate <b>Desktop</b> and <b>Mobile Helpfile</b> links below.
        </Typography>
      </Grid>

      {/* Form Layout */}
      <Grid container spacing={3} style={{ marginTop: '16px' }}>
        {/* Desktop Helpfiles */}
        <Grid item xs={12}>
          <Typography variant="body2">Desktop Helpfiles</Typography>
          <TextField
            fullWidth
            disabled={isMobile || !gameExists}  // Disable if mobile or data is invalid
            value={helpDesktop}
            label="Desktop Helpfiles"
            variant="outlined"
            InputProps={{
              readOnly: true,
            }}
            helperText="Launch link for Flare Help"
          />
        </Grid>

        {/* Mobile Helpfiles */}
        <Grid item xs={12}>
          <Typography variant="body2">Mobile Helpfiles</Typography>
          <TextField
            fullWidth
            disabled={!isMobile || !gameExists}  // Disable if not mobile or data is invalid
            value={helpMobile}
            label="Mobile Helpfiles"
            variant="outlined"
            InputProps={{
              readOnly: true,
            }}
            helperText="Launch link for Mobile Help"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default HelpfilesComponent;
